module.exports = __webpack_public_path__ + "static/media/humidity.2b5cc82d.svg";